/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import CssBaseline from '@mui/material/CssBaseline';
import {ThemeProvider} from '@mui/material/styles';
import {LicenseInfo as MUILicense} from '@mui/x-license/utils/licenseInfo';
import * as React from 'react';

import {config, muiLicenseKey} from '../config';
import {createTheme} from '../styles/create-theme';

MUILicense.setLicenseKey(muiLicenseKey);

interface Props {
  children: React.ReactNode;
}
function CustomThemeProvider({children}: Props): React.JSX.Element {
  const {primaryColor} = config.site;
  const theme = createTheme({primaryColor});
  return (
    <ThemeProvider disableTransitionOnChange theme={theme} defaultMode={'dark'}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export {CustomThemeProvider as ThemeProvider};
